import axios from 'axios';

// Cloudflare R2 upload helper (replaces the old base64 -> backend -> Cloudinary
// flow and the Cloudinary upload widget). Asks the backend for a presigned PUT
// URL, uploads the bytes straight to R2, and returns the public URL to store.
const API_URL = process.env.REACT_APP_API_URL;
const axiosConfig = { withCredentials: true };

const HEIC_MIME = ['image/heic', 'image/heif'];

function isHeic(file) {
  return HEIC_MIME.includes(file.type) || /\.hei[cf]$/i.test(file.name || '');
}

async function maybeConvertHeic(file) {
  if (!isHeic(file)) return file;
  // R2 cannot transcode, so convert iOS HEIC images to JPEG in the browser.
  const heic2any = (await import('heic2any')).default;
  const converted = await heic2any({ blob: file, toType: 'image/jpeg', quality: 0.9 });
  const blob = Array.isArray(converted) ? converted[0] : converted;
  const name = (file.name || 'image').replace(/\.hei[cf]$/i, '.jpg');
  return new File([blob], /\.jpg$/i.test(name) ? name : `${name}.jpg`, { type: 'image/jpeg' });
}

export async function presignAndUpload(file, folder) {
  const prepared = await maybeConvertHeic(file);

  const { data } = await axios.post(
    API_URL + 'uploads/presign',
    { folder, filename: prepared.name, contentType: prepared.type },
    axiosConfig
  );

  if (data.maxBytes && prepared.size > data.maxBytes) {
    throw new Error('FILE_TOO_LARGE');
  }

  const putResponse = await fetch(data.uploadUrl, {
    method: 'PUT',
    headers: { 'Content-Type': prepared.type },
    body: prepared
  });
  if (!putResponse.ok) {
    throw new Error(`R2 upload failed: ${putResponse.status}`);
  }

  return data.publicUrl;
}

export default { presignAndUpload };
